// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"28ea0f50","246":"2db12558"}[chunkId] + ".chunk.js";
};